document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.product-review-trigger');
  var drawer = document.querySelector('.review-drawer');
  if (!trigger || !drawer) return;

  function openReviewDrawer() {
    document.body.classList.add('open-review-drawer');
  }

  function closeReviewDrawer() {
    document.body.classList.remove('open-review-drawer');
  }

  function updateTriggerVisibility() {
    var minReviews = parseInt(trigger.dataset.minReviews, 10) || 5;
    var reviewCount = drawer.querySelectorAll('.yotpo-reviews-item').length;
    trigger.classList.toggle('product-review-trigger--visible', reviewCount >= minReviews);
  }

  updateTriggerVisibility();

  new MutationObserver(updateTriggerVisibility).observe(drawer, {
    childList: true,
    subtree: true,
  });

  trigger.addEventListener(
    'click',
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      openReviewDrawer();
    },
    true
  );

  document.querySelectorAll('[data-review-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeReviewDrawer);
  });
});
